import { FilterInfoSticky } from "@faire/deprecated-retailer-visitor-shared/components/Filters/FilterInfoSticky";
import { FilterName } from "@faire/deprecated-retailer-visitor-shared/components/Filters/FilterName";
import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { useIsSemDiscoverPage } from "@faire/deprecated-retailer-visitor-shared/lib/useIsSemDiscoverPage";
import { useSearchPageFilterRef } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/FilterRefContext";
import { MaybeSearchPageMainHeaderContent } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/MaybeSearchPageMainHeaderContent/MaybeSearchPageMainHeaderContent";
import { SearchPageBrandSearch } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageBrandSearch/SearchPageBrandSearch";
import { SearchPageHeaderHelmet } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageHeaderHelmet/SearchPageHeaderHelmet";
import { useSearchPageShouldShowBrandSearch } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/useSearchPageShouldShowBrandSearch";
import { useSearchPageNonPrimaryContentDeferRender } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPagePerformanceTrackingWrapper";
import { useSearchPageShouldNotShowAnyFiltersForLoggedIn } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageShouldNotShowAnyFiltersForLoggedIn";
import { useIsLoggedOutDiscoverPerfAppTreatment } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useIsLoggedOutDiscoverPerfAppTreatment";
import { useSearchPageIsFromDiscoverURL } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useSearchPageProductSearchString } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { useDiscoverPageShouldShowTopProducts } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/util/useDiscoverPageShouldShowTopProducts";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

interface IProps {
  helmetData: { title: string; description: string; header: string };
}

export const SearchProductsHeader: React.FC<IProps> = ({ helmetData }) => {
  useSearchPageNonPrimaryContentDeferRender();

  const filterRef = useSearchPageFilterRef();
  const isFromDiscoverURL = useSearchPageIsFromDiscoverURL();
  const shouldShowBrandSearch = useSearchPageShouldShowBrandSearch();
  const shouldNotShowFiltersForLoggedIn =
    useSearchPageShouldNotShowAnyFiltersForLoggedIn();

  const productSearchString = useSearchPageProductSearchString();
  const isSemDiscoverPage = useIsSemDiscoverPage();
  const isPerfDiscoverPageTreatment = useIsLoggedOutDiscoverPerfAppTreatment();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const isShowingSectionalDesign = useDiscoverPageShouldShowTopProducts();

  const renderFilter = () => {
    if (shouldNotShowFiltersForLoggedIn) {
      return null;
    }

    if (
      !isShowingSectionalDesign &&
      (isSemDiscoverPage || isPerfDiscoverPageTreatment)
    ) {
      return (
        <>
          <Spacer height="2x" />
          <Typography
            style={{ marginLeft: getSpacing("1x") }}
            variant={{
              mobileAndAbove: "pageHeaderSerifRegular",
              xLargeAndAbove: "displaySSerifRegular",
            }}
            as="h3"
          >
            <StrictLocalMsg
              id="zc0io8"
              defaultMessage="Top products in {titleProductName}"
              values={{
                titleProductName: productSearchString,
              }}
              description={{
                text: "subheading for discover page, encouraging retailers to browse the site",
                img: "https://cdn.faire.com/fastly/7ab0bf0cdb8db14e66933ffe35b46db73faa9f353d04a80d140",
              }}
            />
          </Typography>
        </>
      );
    }

    return (
      <StyledFilterInfoSticky
        name={FilterName.SEARCH}
        shouldShowCarouselArrows
        shouldNotShowFilterCollapsePillOnTabletAndBelow
        shouldEnableScrollToProducts
      />
    );
  };

  return (
    <>
      <SearchPageHeaderHelmet helmetData={helmetData} filterRef={filterRef} />
      {isLoggedInRetailer ? <SearchPageBrandSearch /> : null}
      <MaybeSearchPageMainHeaderContent filterRef={filterRef} />
      {!isLoggedInRetailer && (isLoggedInRetailer || shouldShowBrandSearch) ? (
        <Spacer height={isFromDiscoverURL ? 12 : "1x"} />
      ) : null}
      <>{renderFilter()}</>
    </>
  );
};

const StyledFilterInfoSticky = styled(FilterInfoSticky)`
  ${responsiveMediaQueries.mobile} {
    padding-top: ${getSpacing("1x")};
  }
`;
